/**
 * Location Map Search
 */

import { type App } from '~/app';

import AssetMap from './asset-map/AssetMap.vue';
import EsriMap from './esrimaps-map/EsrimapsMap.vue';
import GmapsMapVue from './gmaps-map/GmapsMap.vue';
import LlcMpcMap from './llc-mpc-map/LlcMpcMap.vue';
import LlcMpcEventMap from './llc-mpc-event-map/LlcMpcEventMap.vue';
import LlcMpcEventMapCards from './llc-mpc-event-map/LlcMpcEventCards.vue';
import LlcMpcMapLlcAmenityCards from './llc-mpc-map/LlcMpcMapLlcAmenityCards.vue';
import LlcMpcMapLlcCommunityCards from './llc-mpc-map/LlcMpcMapLlcCommunityCards.vue';
import LlcMpcMapPropertyCards from './llc-mpc-map/LlcMpcMapPropertyCards.vue';
import LocationMap from './location-map/LocationMap.vue';
import LocationMapSearch from './location-map/LocationMapSearch.vue';

export default (app: App) => {
	app.logger.debug('[Stockland FE] Initialise Stockland Map Components');
	app.vueApp.component('gmaps-map', GmapsMapVue);
	app.vueApp.component('location-map-search', LocationMapSearch);
	app.vueApp.component('location-map', LocationMap);
	app.vueApp.component('asset-map', AssetMap);
	app.vueApp.component('llc-mpc-map', LlcMpcMap);
	app.vueApp.component('llc-mpc-event-map', LlcMpcEventMap);
	app.vueApp.component('llc-mpc-map-property-cards', LlcMpcMapPropertyCards);
	app.vueApp.component('llc-mpc-map-llc-community-cards', LlcMpcMapLlcCommunityCards);
	app.vueApp.component('llc-mpc-map-llc-amenity-cards', LlcMpcMapLlcAmenityCards);
	app.vueApp.component('llc-mpc-event-map-cards', LlcMpcEventMapCards);
	app.vueApp.component('esrimaps-map', EsriMap);
};
